// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn_detail-btn__2nhNw","detail-btn-txt":"DetailBtn_detail-btn-txt__3_ECg","detail-btn-icon":"DetailBtn_detail-btn-icon__KHUpW"};